import {Injectable} from '@angular/core';
import {RDFSubject} from './ontology.model';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AdjusterEventService {
  layerReady: Subject<{name: string}> = new Subject();
  loaded: Subject<{success: boolean; type: 'index' | 'clusters'; err?}> =
    new Subject();
  loaderReady: Subject<void> = new Subject();
  methodChanged: Subject<string> = new Subject();
  ontologyLoads: Subject<Array<RDFSubject>> = new Subject();
  constructor() {}
}
